import script from "./SlideshowView.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideshowView.vue?vue&type=script&setup=true&lang=js"

import "./SlideshowView.vue?vue&type=style&index=0&id=3b615b8c&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b615b8c"]])

export default __exports__